// import React, { useState } from 'react';
// import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
// import { McModal } from "@maersk-global/mds-react-wrapper/components-core/mc-modal";

// const InfoModal = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <>
//       {/* Help Button */}
//       <McButton
//         icon="info-circle"
//         appearance="neutral"
//         fit="small"
//         size="compact"
//         label="Tool Overview"
//         title="Tool Overview & User Guide"
//         click={() => setIsOpen(true)}   // ✅ CORRECT
//       />

//       {/* Modal (ALWAYS rendered) */}
//       <McModal
//        heading="Heading"
//   body="<p>The AFR DA Tool is designed to automate and support AFR case handling across regions.</p>
    
//     <h4>Key Capabilities</h4>
    
//     <ol>
//       <li>The DA Tool reads emails from the AFR shared mailbox and automatically creates cases in the tool.</li>
      
//       <li>
//         The tool consists of the following sections:
//         <ul style='list-style-type: lower-alpha; padding-left: 30px; margin: 10px 0;'>
//           <li>
//             <strong>Metrics Snapshot</strong><br>
//             Used exclusively for reporting purposes. Reports can be viewed at daily, weekly, or monthly levels.
//           </li>
//           <li>
//             <strong>Cargo Mate</strong><br>
//             This is the primary working page where users can view complete case details...
//           </li>
//           <li>
//             <strong>Case Activity Log</strong><br>
//             This page contains the complete historical data for all cases...
//           </li>
//         </ul>
//       </li>
//     </ol>

//     <h4>Case Status Definitions (Cargo Mate)</h4>
    
//     <p>Each case in Cargo Mate will have one of the following statuses:</p>
    
//     <ol>
//       <li><strong>COMPLIANT</strong><br>...</li>
//       <li><strong>NON-COMPLIANT</strong><br>...</li>
//       <li><strong>ON-HOLD</strong><br>...</li>
//       <li><strong>EXCEPTION</strong><br>...</li>
//     </ol>

//     <p style='text-align: center; font-style: italic; margin-top: 2rem; color: #00467F;'>
//       Thank you for being part of this evolving journey!
//     </p>
// "
//         open={isOpen}                      // ✅ THIS IS KEY
//         onMcClosed={() => setIsOpen(false)}
//         click={() => setIsOpen(false)}
//       >
//         <McButton
//           slot="primaryAction"
//           appearance="primary"
//           dialogaction="ok"
//           click={() => setIsOpen(false)}   // ✅ CORRECT
//         >
//           OK
//         </McButton>
//       </McModal>
//     </>
//   );
// };

// export default InfoModal;

import React, { useState } from 'react';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';
import { McModal } from '@maersk-global/mds-react-wrapper/components-core/mc-modal';

const InfoModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Trigger Button */}
      <McButton
        icon="info-circle"
        appearance="neutral"
        variant="outlined"
        fit="small"
        label="Tool Overview"
        title="AFR DA Tool – Overview & User Guide"
        click={() => setIsOpen(true)}
      />

      {/* Modal */}
      <McModal
        dimension="large"
        open={isOpen}
        closed={() => setIsOpen(false)}
        heading="AFR DA Tool – Overview & its capabilities"
       //style={{ height: '80vh', overflowY: 'auto' }}
      >
        {/* BODY — exactly like HTML modal */}

<p>The AFR DA Tool is designed to automate and support AFR case handling across regions.</p>
<br/>

<h4>Key Capabilities</h4>
<br/>

<p>
  The DA Tool reads emails from the AFR shared mailbox and automatically creates cases in the tool.
</p>
<br/>

<p>The tool consists of the following sections:</p>
<br/>

<ol type="a">
  <li>
    <strong>Metrics Snapshot</strong>
    <br/>
    <p>
      Used exclusively for reporting purposes. Reports can be viewed at daily, weekly, or monthly levels.
    </p>
    <br/>
  </li>

  <li>
    <strong>Cargo Mate</strong>
    <br/>
    <p>
      This is the primary working page where users can view complete case details, including:
    </p>
    <br/>
    <ul>
      <li>Customer email content</li>
      <li>POP details</li>
      <li>Shipment and invoice details</li>
      <li>Validation results</li>
      <li>Overall case status</li>
    </ul>
    <br/>
  </li>

  <li>
    <strong>Case Activity Log</strong>
    <br/>
    <p>
      This page contains the complete historical data for all cases. Users can:
    </p>
    <br/>
    <ul>
      <li>Apply filters to search for specific cases</li>
      <li>View detailed case history</li>
      <li>Export case details to CSV format</li>
    </ul>
    <br/>
  </li>
</ol>

<br/>

<h3>Case Status Definitions (Cargo Mate)</h3>
<br/>

<p>Each case in Cargo Mate will have one of the following statuses:</p>
<br/>

<ol>
  <li>
    <strong>COMPLIANT</strong>
    <br/>
    <p>
      The case has passed all global validation rules for all BLs.
    </p>
    <br/>
    <p>
      Users may review the results and, if satisfied, approve or reject the case and manually close the AFR in GCSS for the relevant shipments.
    </p>
    <br/>
  </li>

  <li>
    <strong>NON-COMPLIANT</strong>
    <br/>
    <p>
      The case did not meet validation requirements.
    </p>
    <br/>
    <p>
      Users must manually review the case, take the required actions, and update the final status as compliant or non-compliant with the appropriate reason.
    </p>
    <br/>
    <p>
      Users can communicate with customers and follow up.
    </p>
    <br/>
  </li>

  <li>
    <strong>ON-HOLD</strong>
    <br/>
    <p>
      The case requires additional information.
    </p>
    <br/>
    <p>
      Users must manually review the case and request the required details from the customer.
    </p>
    <br/>
  </li>

  <li>
    <strong>EXCEPTION</strong>
    <br/>
    <p>
      The case requires special handling.
    </p>
    <br/>
    <p>
      Users must manually review the case, request any missing information from the customer, and then approve or reject the case accordingly.
    </p>
    <br/>
  </li>
</ol>

<br/>

<p>Thank you for being part of this evolving journey!</p>


        {/* FOOTER BUTTONS — exactly MDS way */}
        <McButton
          slot="secondaryAction"
          appearance="neutral"
          variant="outlined"
          dialogaction="cancel"
          click={() => setIsOpen(false)}
          label="Close"
        />

        <McButton
          slot="primaryAction"
          appearance="primary"
          dialogaction="ok"
          click={() => setIsOpen(false)}
          label="OK"
        />
      </McModal>
    </>
  );
};

export default InfoModal;
